var _defs, _path, _path2, _path3, _path4, _path5, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodejsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 442.4 270.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 180.7,
    x2: 142.6,
    y1: 80.7,
    y2: 158.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f873f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3f8b3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3e9637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3da92e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3dae2b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 157.2,
    x2: 264,
    y1: 121.3,
    y2: 42.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#3f873f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#529f44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#63b649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#6abf4b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 114.6,
    x2: 212,
    y1: 53.8,
    y2: 53.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#6abf4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#63b649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#529f44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3f873f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "e",
    x1: 114.9,
    x2: 212.3,
    y1: 115.7,
    y2: 115.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "f",
    x1: 114.6,
    x2: 212,
    y1: 143.4,
    y2: 143.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "g",
    x1: 114.9,
    x2: 212.3,
    y1: 156,
    y2: 156
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "h",
    x1: 226.5,
    x2: 166.4,
    y1: 78.4,
    y2: 201
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    transform: "translate(-.3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M166.1 62.6a5 5 0 0 0-5 0L118.8 87a5 5 0 0 0-2.5 4.4V140a5 5 0 0 0 2.5 4.4l42.1 24.3a5 5 0 0 0 5 0l42.2-24.3a5 5 0 0 0 2.6-4.4V91.3a5 5 0 0 0-2.6-4.4z",
    clipRule: "evenodd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#679e63",
    d: "M218.7 271a8.4 8.4 0 0 1-4.2-1.2l-13.3-7.9c-2-1.1-1-1.5-.4-1.7a26.3 26.3 0 0 0 6-2.8 1 1 0 0 1 1 .1l10.2 6a1.3 1.3 0 0 0 1.3 0l40-23a1.3 1.3 0 0 0 .5-1v-46.2a1.3 1.3 0 0 0-.6-1l-40-23a1.2 1.2 0 0 0-1.1 0l-40 23a1.3 1.3 0 0 0-.6 1v46.1a1.2 1.2 0 0 0 .6 1.1l11 6.3c6 3 9.6-.5 9.6-4v-45.5a1.1 1.1 0 0 1 1.1-1.2h5a1.1 1.1 0 0 1 1.2 1.2v45.5c0 8-4.3 12.5-11.8 12.5-2.3 0-4.1 0-9.2-2.5l-10.5-6a8.5 8.5 0 0 1-4.2-7.3v-46.1a8.4 8.4 0 0 1 4.2-7.3l40-23.1a8.8 8.8 0 0 1 8.3 0l40 23a8.4 8.4 0 0 1 4.2 7.4v46a8.5 8.5 0 0 1-4.1 7.3l-40 23.1a8.4 8.4 0 0 1-4.2 1.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#679e63",
    d: "M231 239.2c-17.5 0-21.2-8-21.2-14.8a1.1 1.1 0 0 1 1.2-1.1h5.2a1.1 1.1 0 0 1 1.1 1c.8 5.2 3.1 7.9 13.7 7.9 8.4 0 12-2 12-6.4 0-2.6-1-4.5-14.1-5.8-11-1-17.7-3.5-17.7-12.2 0-8 6.8-12.9 18.2-12.9 12.8 0 19.1 4.5 20 14a1.1 1.1 0 0 1-.4 1 1.2 1.2 0 0 1-.8.3H243a1.1 1.1 0 0 1-1.1-1c-1.3-5.5-4.3-7.2-12.5-7.2-9.2 0-10.3 3.2-10.3 5.6 0 2.9 1.3 3.7 13.7 5.4s18.1 3.9 18.1 12.5-7.2 13.7-20 13.7zm57.6-48.4a7.7 7.7 0 1 1-7.7-7.7 7.7 7.7 0 0 1 7.7 7.7zm-14.2 0a6.5 6.5 0 1 0 6.5-6.4 6.5 6.5 0 0 0-6.5 6.4zm3.6-4.3h3c1 0 3 0 3 2.3a2 2 0 0 1-1.6 2.1c1.1 0 1.2.9 1.4 2a8.5 8.5 0 0 0 .4 2.3h-1.8l-.3-2.7c-.1-.5-.3-.8-1-.8h-1.4v3.5H278zm1.6 3.8h1.4a1.2 1.2 0 0 0 1.3-1.2c0-1.2-.8-1.2-1.3-1.2h-1.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M95 90.5a5.1 5.1 0 0 0-2.6-4.4L50 61.7a5.1 5.1 0 0 0-2.3-.6h-.5a5.2 5.2 0 0 0-2.3.6L2.6 86.1A5.1 5.1 0 0 0 0 90.6v65.6a2.5 2.5 0 0 0 1.4 2.2 2.5 2.5 0 0 0 2.5 0L29.1 144a5.2 5.2 0 0 0 2.6-4.5V109a5.1 5.1 0 0 1 2.5-4.4L45 98.3a5.1 5.1 0 0 1 2.5-.7 5 5 0 0 1 2.6.7l10.7 6.2a5.1 5.1 0 0 1 2.5 4.4v30.6A5.2 5.2 0 0 0 66 144l25 14.4a2.5 2.5 0 0 0 2.6 0 2.6 2.6 0 0 0 1.3-2.2zM298.7.3a2.6 2.6 0 0 0-3.8 2.3v65a1.8 1.8 0 0 1-1 1.5 1.8 1.8 0 0 1-1.7 0L281.6 63a5.1 5.1 0 0 0-5 0L234 87.5a5 5 0 0 0-2.5 4.4v48.9a5.1 5.1 0 0 0 2.6 4.4l42.3 24.5a5.1 5.1 0 0 0 5.1 0l42.4-24.5a5.1 5.1 0 0 0 2.6-4.4v-122a5.1 5.1 0 0 0-2.7-4.4zm-4 124.4a1.3 1.3 0 0 1-.6 1.1l-14.5 8.4a1.3 1.3 0 0 1-1.3 0l-14.5-8.4a1.3 1.3 0 0 1-.7-1v-16.9a1.3 1.3 0 0 1 .6-1l14.6-8.5a1.3 1.3 0 0 1 1.3 0l14.5 8.4a1.3 1.3 0 0 1 .7 1.1zm145.1-17.2a5.1 5.1 0 0 0 2.6-4.4V91.2a5.1 5.1 0 0 0-2.6-4.4l-42.1-24.5a5.1 5.1 0 0 0-5.1 0l-42.4 24.5a5 5 0 0 0-2.5 4.4v49a5.1 5.1 0 0 0 2.6 4.4l42 24a5.1 5.1 0 0 0 5 0l25.5-14.2a2.6 2.6 0 0 0 0-4.5l-42.6-24.4a2.6 2.6 0 0 1-1.3-2.2V108a2.5 2.5 0 0 1 1.3-2.2l13.3-7.7a2.5 2.5 0 0 1 2.5 0l13.3 7.7a2.5 2.5 0 0 1 1.3 2.2v12a2.5 2.5 0 0 0 3.8 2.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#679e63",
    fillRule: "evenodd",
    d: "M394.5 105.2a1 1 0 0 1 1 0l8.2 4.7a1 1 0 0 1 .5.8v9.4a1 1 0 0 1-.5.9l-8.1 4.7a1 1 0 0 1-1 0l-8.2-4.7a1 1 0 0 1-.4-.9v-9.4a1 1 0 0 1 .4-.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "evenodd",
    d: "M166.1 62.6a5 5 0 0 0-5 0L118.8 87a5 5 0 0 0-2.5 4.4V140a5 5 0 0 0 2.5 4.4l42.1 24.3a5 5 0 0 0 5 0l42.2-24.3a5 5 0 0 0 2.6-4.4V91.3a5 5 0 0 0-2.6-4.4z",
    transform: "translate(-.3)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m160.6 62.6-42.2 24.3a5.3 5.3 0 0 0-2.7 4.4V140a4.9 4.9 0 0 0 1.3 3.2l47.4-81.1a5.2 5.2 0 0 0-3.8.5zm4.1 106.6a5 5 0 0 0 1.2-.5l42.1-24.3a5.2 5.2 0 0 0 2.7-4.4V91.3a5 5 0 0 0-1.5-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m208.3 87-42.2-24.4a5 5 0 0 0-1.3-.5l-47.5 81.1a6 6 0 0 0 1.4 1.2l42.4 24.3a5.2 5.2 0 0 0 3.9.5l44.5-81.4a6 6 0 0 0-1.2-.9z",
    transform: "translate(-.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M210.7 140V91.3A5.2 5.2 0 0 0 208 87l-42.2-24.3a5 5 0 0 0-1.6-.6l46.3 79.1a4.5 4.5 0 0 0 .2-1.1zm-92.3-53.1a5.3 5.3 0 0 0-2.7 4.4V140a5.3 5.3 0 0 0 2.7 4.4l42.3 24.3a5.1 5.1 0 0 0 3.3.7l-45.3-82.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m159.3 53.6-.6.4h.8l-.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M208.3 144.4a5.3 5.3 0 0 0 2.5-3.2L164.5 62a5.2 5.2 0 0 0-3.6.6L119 86.8l45.3 82.6a5.2 5.2 0 0 0 1.9-.7z",
    transform: "translate(-.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m212 143.6-.3-.5v.7l.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "m208.3 144.4-42.1 24.3a5.2 5.2 0 0 1-1.9.7l.8 1.5 46.9-27.1v-.7l-1.2-2a5.3 5.3 0 0 1-2.5 3.3z",
    transform: "translate(-.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "m208.3 144.4-42.1 24.3a5.2 5.2 0 0 1-1.9.7l.8 1.5 46.9-27.1v-.7l-1.2-2a5.3 5.3 0 0 1-2.5 3.3z",
    transform: "translate(-.3)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejsLogo);
export default __webpack_public_path__ + "static/media/nodejs-logo.f917ac5c89daa244c1aa10cf47789692.svg";
export { ForwardRef as ReactComponent };